import React, { FC } from 'react';

import BasicButton from 'components/buttons/basicButton';

import aampeTheme from '../../constants/aampeTheme';

interface ShareEditModalFooterProps {
    onClose: () => void;
}
const ShareEditModalFooter: FC<ShareEditModalFooterProps> = ({ onClose }) => {
    return (
        <>
            <div></div>
            <BasicButton
                name="Close"
                isCompact
                isPrimary={false}
                color={aampeTheme.colors.solidA01}
                onClick={onClose}
            />
        </>
    );
};

export default ShareEditModalFooter;
